module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '\n<ul class="mdl_filter__field-tree-items" data-title="' +
((__t = ( category.name )) == null ? '' : __t) +
'" data-level="' +
((__t = ( category.level )) == null ? '' : __t) +
'">\n\n	<li class="mdl_filter__field-tree-item mdl_filter__field-tree-item--back js_filter__field-tree-item-back">\n		<div class="mdl_filter__field-tree-item-label">\n			<span class="mdl_filter__field-tree-item-inner">\n				<span class="mdl_filter__field-tree-item-title">Zurück <span class="mdl_filter__field-tree-item-parentcat">zu <span class="mdl_filter__field-tree-item-parentcat-value">' +
((__t = ( category.name )) == null ? '' : __t) +
'</span></span></span>\n			</span>\n		</div>\n	</li>\n\n	' +
((__t = ( render( 'filter-item', {
		filterGroup,
		filter: {
			...category,
			name: 'Alle Artikel',
			children: [],
			ancestor: false,
			current: false
		},
		index: 'all'
	}) )) == null ? '' : __t) +
'\n\n\n	';
 category.children.forEach( (filter, index) => { ;
__p += '\n\n		' +
((__t = ( render( 'filter-item', {
			filterGroup,
			filter,
			index,
		} ) )) == null ? '' : __t) +
'\n\n	';
 }); ;
__p += '\n</ul>\n';

}
return __p
};
